import { useEffect, useState } from 'react'

export interface TimeLeft {
  days: number
  hours: number
  minutes: number
  seconds: number
  isExpired: boolean
}

function getTimeLeft(deadline: number): TimeLeft {
  const diff = deadline - Date.now()
  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true }
  }
  const totalSeconds = Math.floor(diff / 1000)
  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    isExpired: false,
  }
}

/**
 * Counts down to a real deadline (ISO). The value is derived from the clock on
 * every tick, so reloading the page never restarts the timer.
 */
export function useCountdown(deadlineIso: string): TimeLeft {
  const deadline = new Date(deadlineIso).getTime()
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() =>
    getTimeLeft(deadline),
  )

  useEffect(() => {
    if (getTimeLeft(deadline).isExpired) return
    const interval = window.setInterval(
      () => setTimeLeft(getTimeLeft(deadline)),
      1000,
    )
    return () => window.clearInterval(interval)
  }, [deadline])

  return timeLeft
}
